import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import System from "../pages/system/page";
import Notes from "../pages/notes/page";
import Access from "../pages/access/page";
import Reserve from "../pages/reserve/page";
import Shift from "../pages/shift/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/system",
    element: <System />,
  },
  {
    path: "/shift",
    element: <Shift />,
  },
  {
    path: "/notes",
    element: <Notes />,
  },
  {
    path: "/access",
    element: <Access />,
  },
  {
    path: "/reserve",
    element: <Reserve />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;